import * as Sentry from "@sentry/react";

export interface SentryProps {
  eventId: string;
}

export const openSentryPopup = ({ eventId }: SentryProps): void => {
  Sentry.showReportDialog({ eventId });
};
